import { Controller } from "@hotwired/stimulus"
import debounce from "lodash.debounce"

export default class extends Controller {
  static targets = [ "modal", "movingTagId", "movingTagName", "searchInput", "searchResults", "destinationTagId", "selectedTagContainer", "selectedTagName" ]

  connect() {
    console.log('admin--tags connected')
    this.searchTags = debounce(this.searchTags, 200).bind(this)
  }

  showMoveModal(event) {
    const tagId = event.currentTarget.dataset.tagId
    const tagName = event.currentTarget.dataset.tagName

    this.movingTagIdTarget.value = tagId
    this.movingTagNameTarget.textContent = tagName
    this.searchInputTarget.value = ''
    this.searchResultsTarget.innerHTML = ''
    this.dispatch('showMoveModal', { target: document })
  }

  hideMoveModal() {
    this.dispatch('hideMoveModal', { target: document })
  }

  async searchTags() {
    const query = this.searchInputTarget.value
    if (query.length < 2) {
      this.searchResultsTarget.innerHTML = ''
      return
    }

    const response = await fetch(`/admin/tags/search?q=${query}`)
    const tags = await response.json()

    this.searchResultsTarget.innerHTML = ''

    if (tags.length === 0) return

    const table = document.createElement('table')
    table.classList.add('min-w-full', 'text-sm')

    const thead = document.createElement('thead')
    thead.innerHTML = `
      <tr class="bg-slate-700 text-white">
        <th class="p-2 text-left">ID</th>
        <th class="p-2 text-left">Name</th>
        <th class="p-2 text-left">Products</th>
      </tr>
    `
    table.appendChild(thead)

    const tbody = document.createElement('tbody')
    table.appendChild(tbody)

    tags.forEach(tag => {
      if (tag.id.toString() !== this.movingTagIdTarget.value) {
        const row = document.createElement('tr')
        row.classList.add('cursor-pointer', 'hover:bg-slate-700', 'even:bg-slate-900', 'even:bg-opacity-30', 'transition')
        row.dataset.action = 'click->admin--tags#selectTag'
        row.dataset.tagId = tag.id
        row.dataset.tagName = tag.name

        row.innerHTML = `
          <td class="p-2">${tag.id}</td>
          <td class="p-2 font-bold">${tag.name}</td>
          <td class="p-2">${tag.products_count}</td>
        `

        tbody.appendChild(row)
      }
    })

    this.searchResultsTarget.appendChild(table)
  }

  selectTag(event) {
    const tagId = event.currentTarget.dataset.tagId
    const tagName = event.currentTarget.dataset.tagName

    this.destinationTagIdTarget.value = tagId
    this.selectedTagNameTarget.textContent = tagName
    this.selectedTagContainerTarget.classList.remove('hidden')
    this.searchInputTarget.value = ''
    this.searchResultsTarget.innerHTML = ''
  }

  clearSelection() {
    this.destinationTagIdTarget.value = ''
    this.selectedTagNameTarget.textContent = ''
    this.selectedTagContainerTarget.classList.add('hidden')
  }

  async confirmMove() {
    const fromId = this.movingTagIdTarget.value
    const toId = this.destinationTagIdTarget.value

    if (!toId) {
      // You might want to show an error to the user here
      return
    }

    const response = await fetch(`/admin/tags/${fromId}/move`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content
      },
      body: JSON.stringify({ destination_tag_id: toId })
    })

    if (response.ok) {
      // Reload the page to see the changes
      window.location.reload()
    } else {
      // Handle errors, e.g., show a notification
      const error = await response.json()
      alert(`Error: ${error.message}`)
    }
  }
}
